export const getShouldShowScopeChangeAlert = ({
  scopeChangeInfo,
  alertRequiresCount = true,
  isPageUsingScope = false,
  viewMode
}) => {
  const {
    count,
    purgedTime,
    status
  } = scopeChangeInfo;
  const isScopeLost = purgedTime !== null && status !== 'NOT_PURGED';
  if (!isScopeLost) {
    return false;
  }
  if (viewMode === 'LIST') {
    return !alertRequiresCount || count !== 0;
  }
  return isPageUsingScope;
};